import { render, staticRenderFns } from "./SsePage.vue?vue&type=template&id=78ea07f2"
import script from "./SsePage.vue?vue&type=script&lang=js"
export * from "./SsePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports